import { Row } from 'antd';
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

export const ActionButtonStyled = styled(ButtonWithSpinner)`
  background-color: transparent !important;
  width: auto !important;
  height: auto !important;
  white-space: normal;
  line-height: 1.3;
  border: none;
  &:hover {
    background-color: transparent !important;
  }
  @media (max-width: ${breakpoints.md}) {
    width: 100% !important;
  }
`;

export const UserActionButtonsContainerStyled = styled(Row)`
  align-items: center;
  flex-wrap: wrap;
  @media screen and (max-width: ${breakpoints.sm}) {
    justify-content: center;
  }
`;

export const NewCardActionButtonStyled = styled(ButtonWithSpinner)`
  background-color: transparent !important;
  white-space: normal;
  line-height: 1.3;
  border: none;
  &:hover {
    background-color: transparent !important;
  }
  @media (max-width: ${breakpoints.md}) {
    width: 100% !important;
  }
`;
